import React, { useState, useEffect } from 'react';
import './Pages.css';

const About = () => {
  const [members, setMembers] = useState([]);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    // Load members data from CMS API
    const loadMembersData = async () => {
      try {
        // Use Netlify Functions in production, localhost in development
        const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const apiUrl = isDevelopment 
          ? 'http://localhost:3001/api/cms/members' 
          : '/.netlify/functions/cms-members';
        
        const response = await fetch(apiUrl);
        if (response.ok) {
          const membersData = await response.json();
          setMembers(membersData);
        } else {
          console.error('Failed to fetch members:', response.status);
          setMembers([]);
        }
      } catch (error) {
        console.error('Error loading members data:', error);
        setMembers([]);
      }
    };

    const loadSettingsData = async () => {
      try {
        // Load settings from CMS
        const settingsData = {
          aboutIntro: "Incorporated in 1996, around a 1972 Grumman Traveler at the York airport, York Travelers Flying Club is a non-profit organization of 5 - 10 pilots who want to fly a well-maintained cross-country airplane at a reasonable cost.",
          history: "In 2000, we sold the Traveler & purchased a 1978 Grumman Tiger. We also moved 25 miles east to Donegal Springs Airpark. The move to N71 made YTFC equidistant from Harrisburg, Lancaster & York, PA.",
          resources: "Visit our companion website for more information about Grumman aircraft: Grumman Proficiency"
        };
        setSettings(settingsData);
      } catch (error) {
        console.error('Error loading settings data:', error);
      }
    };

    loadMembersData();
    loadSettingsData();
  }, []);

  return (
    <div className="page-container">
      <h1 className="page-title">About Us</h1>
      <div className="page-content">
        <div className="about-section">
          <p className="about-intro">
            {settings.aboutIntro || "Incorporated in 1996, around a 1972 Grumman Traveler at the York airport, York Travelers Flying Club is a non-profit organization of 5 - 10 pilots who want to fly a well-maintained cross-country airplane at a reasonable cost."}
          </p>
          
          <div className="about-history">
            <h2>Our History</h2>
            <p>
              {settings.history || "In 2000, we sold the Traveler & purchased a 1978 Grumman Tiger. We also moved 25 miles east to Donegal Springs Airpark. The move to N71 made YTFC equidistant from Harrisburg, Lancaster & York, PA."}
            </p>
          </div>

          <div className="about-resources">
            <h2>Resources</h2>
            <p>
              {settings.resources || "Visit our companion website for more information about Grumman aircraft:"}
            </p>
            <a 
              href="https://grummanproficiency.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="resource-link"
            >
              Grumman Proficiency
            </a>
          </div>

          <div className="about-members">
            <h2>Current Members</h2>
            <div className="members-grid">
              {members.map((member, index) => (
                <div key={index} className="member-card">
                  <h3>{member.name}</h3>
                  <p>{member.rating}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 